// extracted by mini-css-extract-plugin
module.exports = {"flag":"LanguageSelector_flag__tHo3J","langToogle":"LanguageSelector_langToogle__eXeAG","link":"LanguageSelector_link__jpNMS"};